let columnas=[{
    label: 'Personal',
    field: 'personal',
    width: '20%',
    thClass: 'text-nowrap',
    tdClass: 'text-nowrap'
},
{
    label: 'Tipo',
    field: 'tipo_descripcion',
    width: '10%',
    tdClass: 'text-nowrap ',
    thClass: 'text-nowrap '
},
{
    label: 'Inicial',
    field: 'inicial',
    width: '10%',
    tdClass: 'text-nowrap ',
    thClass: 'text-nowrap '
},
{
    label: 'Final',
    field: 'final',
    width: '10%',
    tdClass: 'text-nowrap ',
    thClass: 'text-nowrap '
},
{
    label: 'Observaciones',
    field: 'observaciones',
    width: '30%',
    tdClass: 'text-nowrap ',
    thClass: 'text-nowrap '
},
{
    label: 'Fecha',
    field: 'fecha_add',
    width: '10%',
    tdClass: 'text-nowrap ',
    thClass: 'text-nowrap '
},

{
    label: 'Detalle',
    field: 'detalle',
    width: '10%',
    tdClass: 'text-center ',
    thClass: 'text-center '
},
];
export default {
    columnas,  
  } 